import { Modal } from './classes/modal';
export default class ModalService {
    constructor() {
        this.instances = [];
        document.addEventListener('dataModalChanged', (e) => {
            const detail = e.detail || {};
            console.log('[ModalService] dataModalChanged event received. detail:', detail);
            this.init();
        });
    }
    init() {
        console.log('[ModalService] init called, removing old listeners...');
        this.instances.forEach(({ button, listener, modal }) => {
            button.removeEventListener('click', listener);
            if (typeof modal.destroy === 'function') {
                modal.destroy();
            }
        });
        this.instances = [];
        const buttons = document.querySelectorAll('[data-modal]');
        console.log(`[ModalService] Found ${buttons.length} button(s) with [data-modal]`);
        buttons.forEach((buttonEl) => {
            if (!(buttonEl instanceof HTMLElement))
                return;
            const modalId = buttonEl.getAttribute('data-modal');
            if (!modalId) {
                console.warn('[ModalService] Found element with no data-modal attribute:', buttonEl);
                return;
            }
            console.log(`[ModalService] Creating a Modal instance for ID: ${modalId}`);
            const modalInstance = new Modal(modalId);
            const listener = () => {
                console.log(`[ModalService] Opening modal: ${modalId}`);
                modalInstance.open();
            };
            buttonEl.addEventListener('click', listener);
            this.instances.push({ modal: modalInstance, button: buttonEl, listener });
        });
    }
    observeChanges() {
        const observer = new MutationObserver((mutations) => {
            let shouldReinit = false;
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-modal') {
                    console.log('[ModalService] data-modal attribute changed on:', mutation.target);
                    console.log('Old value:', mutation.oldValue);
                    shouldReinit = true;
                }
                mutation.addedNodes.forEach((node) => {
                    if (node instanceof HTMLElement &&
                        (node.matches('[data-modal]') || node.querySelector('[data-modal]'))) {
                        console.log('[ModalService] New element(s) with data-modal detected:', node);
                        shouldReinit = true;
                    }
                });
            });
            if (shouldReinit) {
                console.log('[ModalService] Detected relevant DOM changes, reinitializing...');
                this.init();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['data-modal'],
            attributeOldValue: true,
        });
        console.log('[ModalService] MutationObserver is now watching for changes...');
    }
}
